import React from 'react'

import { Tile } from '~/components/tile/Tile'
import { styled } from '~/styled'
import { NavigatorActions } from '~/types/navigatorActions.types'

const StyledTileInteractive = styled(Tile, {
  base: [
    'disabled:cursor-not-allowed',
    'disabled:opacity-30',
    'not-disabled:active:bg-(--base-2)',
    'not-disabled:after:absolute',
    'not-disabled:after:duration-250',
    'not-disabled:after:ease-out',
    'not-disabled:after:inset-0',
    'not-disabled:after:opacity-0',
    'not-disabled:after:pointer-events-none',
    'not-disabled:after:rounded-[inherit]',
    'not-disabled:after:shadow-lg',
    'not-disabled:after:transition-opacity',
    'not-disabled:cursor-pointer',
    'not-disabled:duration-250',
    'not-disabled:ease-in',
    'not-disabled:focus-visible:outline-none',
    'not-disabled:focus-visible:relative',
    'not-disabled:focus-visible:shadow-[var(--color-primary-800)_0px_0px_0px_4px]',
    'not-disabled:focus-visible:shadow-[white_0px_0px_0px_2px]',
    'not-disabled:focus-visible:z-1',
    'not-disabled:hover:after:opacity-100',
    'not-disabled:hover:-translate-y-0.5',
    'not-disabled:transition-transform',
    'not-disabled:translate-y-0'
  ]
})

type TTileInteractiveProps = React.ComponentProps<
  typeof StyledTileInteractive
> &
  React.ButtonHTMLAttributes<HTMLButtonElement> &
  NavigatorActions

export const TileInteractive = React.forwardRef<
  HTMLDivElement,
  TTileInteractiveProps
>(({ onClick, href, type = 'button', as, ...rest }, ref) => {
  const isLink = !!href
  const elementSpecificProps = isLink
    ? {
        as: as || ('a' as React.ElementType),
        href,
        onClick: undefined
      }
    : {
        as: as || ('button' as React.ElementType),
        type,
        onClick
      }

  return <StyledTileInteractive {...rest} {...elementSpecificProps} ref={ref} />
})

TileInteractive.displayName = 'TileInteractive'
